<template>
  <div class="login flex justify-center items-center min-h-screen">
    <loading :active.sync="isLoading"></loading>
    <div class="sm:w-56 md:w-full max-w-md mx-auto">
      <form
        class="bg-white shadow-md rounded-lg px-8 pt-16 pb-16 mb-4 mt-4"
        autocomplete="off"
      >
        <label class="block mb-4">
          <label class="block mb-4">
            <validation-provider
              name="Restaurant Name"
              rules="required"
              v-slot="{ errors }"
            >
              <span class="text-gray-700">{{ $t('Restaurant Name') }}</span>
              <input
                class="form-input mt-1 block w-full"
                v-model="form.name"
                :placeholder="$t('Restaurant Name')"
              />
              <span class="text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </label>

          <validation-provider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <span class="text-gray-700">{{ $t('Email') }}</span>
            <input
              class="form-input mt-1 block w-full"
              v-model="form.email"
              :placeholder="$t('Email')"
            />
            <span class="text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </label>

        <label class="block mb-4">
          <validation-provider
            name="password"
            rules="required|min:6"
            v-slot="{ errors }"
          >
            <span class="text-gray-700">{{ $t('Password') }}</span>
            <input
              class="form-input mt-1 block w-full"
              v-model="form.password"
              placeholder="****************"
              type="password"
            />
            <span class="text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </label>

        <label class="block mb-4">
          <validation-provider
            name="password"
            rules="required|min:6"
            v-slot="{ errors }"
          >
            <span class="text-gray-700">{{ $t('Repeat Password') }}</span>
            <input
              class="form-input mt-1 block w-full"
              v-model="form.passwordRepeat"
              placeholder="****************"
              type="password"
            />
            <span class="text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </label>

        <label class="block mb-4">
          <validation-provider
            name="phone"
            rules="required"
            v-slot="{ errors }"
          >
            <span class="text-gray-700">{{ $t('Phone') }}</span>
            <input
              class="form-input mt-1 block w-full"
              v-model="form.phone"
              :placeholder="$t('Phone')"
            />
            <span class="text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </label>

        <label class="block mb-6">
          <validation-provider
            name="address"
            rules="required"
            v-slot="{ errors }"
          >
            <span class="text-gray-700">{{ $t('Address') }}</span>
            <textarea
              class="form-textarea mt-1 block w-full"
              rows="3"
              v-model="form.address"
              :placeholder="$t('Address')"
            ></textarea>
            <span class="text-red-700">{{ errors[0] }}</span>
          </validation-provider>
        </label>

        <div class="flex items-center justify-center">
          <button
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            @click="handleSignup"
          >
            {{ $t('Signup') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { auth, db } from '@/firebase';

export default {
  name: 'AdminSignup',
  data() {
    return {
      isLoading: false,
      form: {
        email: '',
        password: '',
        passwordRepeat: '',
        phone: '',
        name: '',
        address: '',
      },
    };
  },
  methods: {
    async handleSignup() {
      this.isLoading = true;
      try {
        const { email, password, name, phone, address } = this.form;
        const response = await auth.createUserWithEmailAndPassword(email, password);
        const { uid, emailVerified } = response.user;

        if (emailVerified === false) {
          await response.user.sendEmailVerification();
        }

        await db
          .collection('restaurants')
          .doc(uid)
          .set({
            email,
            name,
            address,
            phone,
          });

        this.isLoading = false;
        this.$toasted.success(this.$t('Signed up successfully!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
        this.$router.push('verification');
      } catch (e) {
        console.log('e :', e);
        this.isLoading = false;
        this.$toasted.error(this.$t('Error while signing up!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      }
    },
  },
};
</script>

<style></style>
